module.exports = __webpack_public_path__ + "img/latvia.fb740b6.webp";